import Icons from "@/src/components/Icons";
import { useUserStore } from "@/src/store/useUserStore";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { useNavigate } from "react-router-dom";
import UserMap from "./Location";
import emptmom from "../../assets/img/emptMom.png";

function Showprofile() {
  let history = useNavigate();
  const { user, clearUser } = useUserStore();
  return (
    <div>
      <div className="header flex justify-between items-center">
        <h4
          className="title text-xl font-extrabold flex items-center cursor-pointer"
          onClick={() => history("/profile")}
        >
          <Icons name="arrowBack" fill="none" size={40} />
          اطلاعات
        </h4>

        <h5
          className="font-bold flex gap-2 items-center cursor-pointer"
          onClick={() => {
            clearUser();
            history("/");
          }}
        >
          خروج <Icons name="logout" fill="none" size={40} />
        </h5>
      </div>
      <div className="flex flex-col mt-20 gap-4">
        <div className="min-h-[300px] bg-white rounded-xl shadow-mmpz p-2 pt-6">
          <div className="flex justify-center relative border-b-gray-100-mmpz pb-2 border-b">
            <img
              src={
                user?.profilePictureUrl
                  ?  user.profilePictureUrl
                  : emptmom
              }
              alt=""
              className="w-[80px] h-[80px] rounded-full shadow-xl absolute -top-16"
            />
            <span className="pt-12 font-bold">{user?.alias}</span>
          </div>
          <div className="border-b-gray-100-mmpz border-b flex flex-col gap-2 py-2">
            <p className="flex justify-between text-[#4B4B4B]">
              شماره موبایل{" "}
              <span className="text-[#A5A5A5] font-light">
                {user ? digitsEnToFa(user.mobilePhoneNumber) : null}
              </span>
            </p>
            <p className="flex justify-between text-[#4B4B4B]">
              شماره ثابت{" "}
              <span className="text-[#A5A5A5] font-light">
                {user ? digitsEnToFa(user.phoneNumber) : null}
              </span>
            </p>
          </div>
          <div className="flex py-2 items-center">
            <div className="w-1/2 flex gap-2">
              <div className="w-[40px]">
                <Icons name="locationMark" fill="none" size={30} />
              </div>
              <p className="text-gray-200-mmpz text-sm">
                {user?.address.fullAddress}
              </p>
            </div>
            <div className="w-1/2 flex justify-center">
              <UserMap />
            </div>
          </div>
        </div>
        <div className="item-goftino min-h-[76px] flex flex-col justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer w-full">
          <p className="flex justify-between text-[#4B4B4B] w-full">
            بانک{" "}
            <span className="text-[#A5A5A5] font-light">
              {user?.paymentInfo.bankName}
            </span>
          </p>
          <p className="flex justify-between text-[#4B4B4B] w-full">
            شماره شبا{" "}
            <span className="text-[#A5A5A5] font-light">
              {user ? digitsEnToFa(user.paymentInfo.sheba) : null}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Showprofile;
